import { MenuControllerId, MenuItem } from '@adaptiva/core/menus';
import { EBuiltInIds, EJavaClassNames, Folder, ServerObjectTreeMenuController } from '@adaptiva/data-service';
import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { CloudRelayServer } from '../../java';

@Injectable()
export class CloudRelayServerTreeMenuController extends ServerObjectTreeMenuController<CloudRelayServer> {

	public static override readonly id: MenuControllerId.Any = `${MenuControllerId.Prefix.Tree}${EJavaClassNames.CloudRelayServer}`;

	public override getClassName(): string {
		return EJavaClassNames.CloudRelayServer;
	}

	protected override createObject(_item: MenuItem): void {
		const _server: CloudRelayServer = new CloudRelayServer();

		_server.parentFolderId = (
			this.isFolderLike<Folder>(_item.data) ? _item.data.objectId : _item.data.parentFolderId
		) || EBuiltInIds.ROOT_FOLDER_CLOUD_RELAY_SERVER_OBJECT;

		this.overlays.load({
			overlayId: 'CloudRelayServerActionOverlayComponent',
			context: this.summarize.generate(_server.javaClassName, _server)
		}).pipe(take(1)).subscribe();
	}
}
